module.exports = __webpack_public_path__ + "img/jypx-7.789d8774.webp";